import { createContext } from "react";

/**
 * A request to open one Running order row for editing, from a view over the
 * same plan (the teaching view's Change this activity). Each request carries
 * a new token.
 */
export const OutlineOpenRequest = createContext<{ id: string; token: number } | null>(null);
